import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type {
  ConcertCreateQuoteDto,
  ConcertQuoteResponseDto,
} from "../dto/concert.dto"
import { concertService } from "../services/concert.service"

type CreateConcertQuoteVariables = {
  proposalId: string
  data: ConcertCreateQuoteDto
}

export const useCreateConcertQuote = (): UseMutationResult<
  ConcertQuoteResponseDto,
  unknown,
  CreateConcertQuoteVariables
> => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ proposalId, data }: CreateConcertQuoteVariables) => {
      return concertService.createQuote(proposalId, data)
    },
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: queryKeys.proposal.savings(variables.proposalId),
        refetchType: `active`,
      })
    },
  })
}
